// extracted by mini-css-extract-plugin
module.exports = {"styleMenu":"SupplierDetailPage_styleMenu__1UvNF","stickyContainer":"SupplierDetailPage_stickyContainer__34B61","heightCard":"SupplierDetailPage_heightCard__3KWS7"};